/* eslint-disable camelcase */
import { pickBy } from 'lodash';
import { appLog } from 'utils/helpers';
import { location as UrlHelperLocation } from 'common/utils/url-helper';

const { isPreview } = UrlHelperLocation.client;
const log = appLog.extend('utils:analytics');

const pickValid = (o: Record<any, any>): Record<any, any> => pickBy(o, v => v !== null && v !== undefined && v !== '');

/**
 * @info https://developers.google.com/analytics/devguides/collection/gtagjs/events
 */
export function track({
	type,
	action,
	payload,
}: {
	type: string;
	action: string;
	payload: { [key: string]: string | number | boolean };
}) {
	try {
		if (isPreview) {
			return;
		}

		if (!window.gtag) {
			console.warn("gtag is't initialized");
			return;
		}

		log('gtag', type, action, payload);
		window.gtag(type, action, pickValid(payload));
	} catch (error) {
		console.warn('Failed to track analytics event', error);
	}
}

export const analytics = {
	onLinkClick: (params: { storyId: string; cardId: string; name: string }) =>
		track({
			type: 'event',
			action: `link click story ${params.storyId} | card ${params.cardId} | ${params.name}`,
			payload: {
				event_category: 'Link click',
				layerName: params.name,
				storyId: params.storyId,
				cardId: params.cardId,
			},
		}),
	onApiRetry: (attemptNumber, apiRequestName) =>
		track({
			type: 'event',
			action: `Retry ${attemptNumber} - ${apiRequestName}`,
			payload: {
				event_category: 'Retry to api',
				event_label: `${apiRequestName}`,
			},
		}),
	onApiError: (errorCode, apiRequestName) =>
		track({
			type: 'event',
			action: `${apiRequestName}`,
			payload: {
				event_category: 'Error from api',
				event_label: `${errorCode} code`,
			},
		}),
	onOffline: (storyId, cardId, requestRoute) =>
		track({
			type: 'event',
			action: `offline mode storyid ${storyId} card ${cardId}`,
			payload: {
				event_category: 'offline mode no session',
				event_label: `${requestRoute}`,
			},
		}),
	onSendAnswer: (storyId, cardId, answerId, answerText) =>
		track({
			type: 'event',
			action: `Send Answer story ${storyId} card ${cardId} `,
			payload: {
				event_category: 'Send answer',
				event_label: `answer ${answerId} ${answerText}`,
			},
		}),
};

/**
 * @param location {String} The page's URL.
 * @param path {String} The path portion of location. This value must start with a slash (/) character.
 * @param title {String} The page's title.
 * @param send_to {String=} GA_MEASUREMENT_ID
 * @info https://developers.google.com/analytics/devguides/collection/gtagjs/pages
 */
export const pageview = ({ location = '', path = '', title = '', send_to = '' }) => {
	if (isPreview) {
		return;
	}

	if (!window.gtag) {
		console.warn("gtag is't initialized");
		return;
	}

	log('pageview', { location, path, title, send_to });

	window.gtag(
		'event',
		'page_view',
		pickValid({
			page_path: path,
			page_title: title,
			page_location: location,
			send_to,
		})
	);
};
